import {
  convertDateToYYYYMMFormat,
  MonthYearDatePicker,
  PageWrapper,
  STATUSPAGE,
} from '@repo/ui';
import { GetStudentsFrequencyReportParams } from 'domain/models';
import { useFormik } from 'formik';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { ReportsGeneralFilters } from 'presentation/app/modules/Reports/components/reports-general-filters';
import { useCallback, useState } from 'react';
import { Card, Col, Input, Label, Row, Spinner } from 'reactstrap';
import * as Yup from 'yup';

export const StudentsFrequencyReport = () => {
  const [buttonSelectedSubmit, setButtonSelectedSubmit] =
    useState<string>(null);
  const [statusGet, setStatusGet] = useState<STATUSPAGE>();

  const { reportService } = useService();

  // Methods
  const requestGetStudentsFrequncyReport = useCallback(
    async (params: GetStudentsFrequencyReportParams) => {
      setStatusGet(STATUSPAGE.LOADING);

      await reportService
        .getStudentsFrequencyReport(params)
        .then((res: never) => {
          let blob = new Blob([res], {
            type: `application/${'pdf'}`,
          });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, '_blank');
        })
        .catch((err) => {
          notifyError(err.message);
        })
        .finally(() => {
          setStatusGet(STATUSPAGE.DONE);
        });
    },
    [],
  );

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      unit: null,
      groups: [],
      semester: null,
      entity: null,
      course: null,
      reportType: 'agrupado',
      period: convertDateToYYYYMMFormat(new Date()).slice(0, 7),
    },
    validationSchema: Yup.object({
      unit: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      semester: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      groups: Yup.array().of(
        Yup.object()
          .shape({
            label: Yup.string(),
            value: Yup.string(),
          })
          .nullable(),
      ),
      entity: Yup.object()
        .shape({
          label: Yup.string().required('Campo é Obrigatório.'),
          value: Yup.string().required('Campo é Obrigatório.'),
        })
        .nullable(),
      course: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      reportType: Yup.string(),
      period: Yup.date().required('Campo é obrigatório'),
    }),

    onSubmit: (values) => {
      const groupsValues = values.groups.map((group) => group.value);

      {
        buttonSelectedSubmit === 'export-pdf' &&
          requestGetStudentsFrequncyReport({
            groups: groupsValues,
            curricularUnit: validation?.values?.unit?.value,
            entity: validation?.values?.entity?.value,
            course: validation?.values?.course?.value,
            semester: validation?.values?.semester?.value,
            report_style: values.reportType || null,
            period: values.period,
          });
      }
    },
  });

  return (
    <PageWrapper title="Frequência de Estudantes">
      <Col className="mb-3 border-0 d-flex align-items-end justify-content-between">
        <h4>Frequência de Estudantes</h4>
      </Col>

      <Card>
        <ReportsGeneralFilters
          validation={validation}
          buttonsChildren={
            <div className="text-start">
              <button
                type="submit"
                id="export-pdf"
                onClick={() => {
                  setButtonSelectedSubmit('export-pdf');
                }}
                className="btn btn-light waves-effect waves-light"
                disabled={statusGet === STATUSPAGE.LOADING && true}
              >
                {statusGet === STATUSPAGE.LOADING ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Visualizar
                    <i className="las la-file-pdf mx-2"></i>
                  </>
                )}
              </button>
            </div>
          }
          inputsChildren={
            <Row className="mb-3">
              <Col xl={2} className="d-flex flex-column">
                <Label>Período:</Label>
                <MonthYearDatePicker
                  validation={validation}
                  fieldName="period"
                />
              </Col>
              <Col md={4}>
                <Label className="form-label">Tipo do Relatório</Label>
                <div className="d-flex justify-content-between align-items-center">
                  <Col>
                    <Input
                      id="reportTypeGroup"
                      name="reportType"
                      className="me-2"
                      type="radio"
                      value={'agrupado'}
                      onBlur={validation.handleBlur}
                      checked={validation.values.reportType === 'agrupado'}
                      onChange={(e) => {
                        if (e.target.value === 'agrupado') {
                          validation.handleChange({
                            target: {
                              name: 'reportType',
                              value: 'agrupado',
                            },
                          });
                        }
                      }}
                      invalid={
                        !!(
                          validation?.touched && validation?.errors?.reportType
                        )
                      }
                    />

                    <Label htmlFor="reportTypeGroup" className="text-muted">
                      Agrupado por grupo
                    </Label>
                  </Col>

                  <Col>
                    <Input
                      id="reportTypeConsolidated"
                      name="reportType"
                      className="me-2"
                      type="radio"
                      value={'consolidado'}
                      onBlur={validation.handleBlur}
                      checked={validation.values.reportType === 'consolidado'}
                      onChange={(e) => {
                        if (e.target.value === 'consolidado') {
                          validation.handleChange({
                            target: {
                              name: 'reportType',
                              value: 'consolidado',
                            },
                          });
                        }
                      }}
                    />
                    <Label
                      htmlFor="reportTypeConsolidated"
                      className="text-muted"
                    >
                      Consolidado
                    </Label>
                  </Col>
                </div>
              </Col>
            </Row>
          }
        />
      </Card>
    </PageWrapper>
  );
};
